import request from '@utils/request'
import configRequest from "@src/config/request";

export const state = {
  currentApplicablePrepaidOrderList: []
};

export const getters = {};

export const mutations = {
  SET_CURRENT_MEMBER_AVAILABLE_PREPAID_LIST(state, newValue) {
    state.currentApplicablePrepaidOrderList = newValue;
  },
};

export const actions = {
  /**
   * 清除會員可使用包套方案列表
   * @param commit
   */
  clearApplicablePrepaidOrderList({ commit }) {
    commit('SET_CURRENT_MEMBER_AVAILABLE_PREPAID_LIST', []);
  },

  /**
   * 取得預約訂單列表
   * @param commit
   * @param storeAlias
   * @param status
   * @param paymentStatus
   * @param orderBy
   * @param limit
   * @param page
   * @param types
   * @returns {*}
   */
  fetchReservationOrderList({ commit }, {
    storeAlias,
    status,
    paymentStatus,
    orderBy,
    limit = 9,
    page = 1,
    types
  } = {}) {
    return request
      .post(`/merchant/member/order/search`, {
        storeAlias,
        status,
        paymentStatus,
        orderBy,
        limit,
        page,
        types
      }, {
        ...configRequest,
        name: 'fetchReservationOrderList'
      })
  },

  /**
   * 取得預約訂單項目
   * @param commit
   * @param orderId
   * @param errorHandle
   * @param logoutRedirect
   * @param showMessage
   * @returns {*}
   */
  fetchReservationOrderItem({ commit }, {
    orderId,
    errorHandle = true,
    logoutRedirect = true,
    showMessage = true
  }) {
    return request
      .get(`/merchant/member/order/${orderId}`, {
        ...configRequest,
        name: 'fetchReservationOrderItem',
        errorHandle,
        logoutRedirect,
        showMessage
      })
  },

  /**
   * 結帳預約訂單項目
   * @param commit
   * @param cart
   * @param orderId
   * @returns {*}
   */
  checkoutReservationOrderItem({ commit }, {
    cart,
    orderId
  } = {}) {
    return request
      .post(`/merchant/member/order/${orderId}/checkout`, {
        ...cart
      }, {
        ...configRequest,
        name: 'checkoutReservationOrderItem'
      })
  },

  /**
   * 取得預約容器訂單項目
   * @param commit
   * @param containerUuId
   * @param errorHandle
   * @param logoutRedirect
   * @param showMessage
   * @returns {*}
   */
  fetchContainerOrderItem({ commit }, {
    containerUuId,
    errorHandle = true,
    logoutRedirect = true,
    showMessage = true
  }) {
    return request
      .get(`/merchant/member/order/container/${containerUuId}`, {
        ...configRequest,
        name: 'fetchContainerOrderItem',
        errorHandle,
        logoutRedirect,
        showMessage
      })
  },

  /**
   * 取得包套方案訂單列表
   * @param commit
   * @param state
   * @param status
   * @param storeAlias
   * @param sizeAlias
   * @param limit
   * @param page
   * @returns {*}
   */
  fetchPrepaidOrderList({
    commit,
    state
  }, {
    status,
    orderBy = 'created',
    canUse = 0,
    limit = 9,
    page = 1,
  } = {}) {
    return request
      .post('/merchant/member/prepaid/order/search', {
        status,
        orderBy,
        canUse,
        limit,
        page,
      }, {
        ...configRequest,
        name: 'fetchPrepaidOrderList'
      })
  },

    /**
     * 取得會員可使用包套方案列表
     * @param commit
     * @param state
     * @param paramAlias
     * @param storeAlias
     * @param sizeAlias
     * @param canUse
     * @param useCached
     * @param storeCached
     * @param limit
     * @param page
     * @param date
     * @param servicePriceGroupId,
     * @returns {/* Vuex store state */
  fetchApplicablePrepaidOrderList({
    commit,
    state
  }, {
    paramAlias,
    storeAlias,
    sizeAlias,
    canUse = 1,
    limit = 100,
    page = 1,
    useCached = false,
    storeCached = true,
    petId,
    date,
    servicePriceGroupId,
  } = {}) {
    const cached = state.currentApplicablePrepaidOrderList;
    const hasCached = !!cached && cached[0];

    return hasCached && useCached
      ? state
      : request
        .post('/merchant/member/prepaid/order/search', {
          storeAlias,
          sizeAlias,
          petId,
          paramAlias,
          canUse,
          limit,
          page,
          date,
          servicePriceGroupId,
        }, {
          ...configRequest,
          name: 'fetchApplicablePrepaidOrderList'
        })
        .then((response) => {
          if(storeCached) {
            commit('SET_CURRENT_MEMBER_AVAILABLE_PREPAID_LIST', response.items);
          }

          return response
        })
  },

  /**
   * 取得包套方案訂單項目
   * @param commit
   * @param prepaidOrderId
   * @param errorHandle
   * @param logoutRedirect
   * @param showMessage
   * @returns {*}
   */
  fetchPrepaidOrderItem({ commit }, {
    prepaidOrderId,
    errorHandle = true,
    logoutRedirect = true,
    showMessage = true
  } = {}) {
    return request
      .get(`/merchant/member/prepaid/order/${prepaidOrderId}`, {
        ...configRequest,
        name: 'fetchPrepaidOrderItem',
        errorHandle,
        logoutRedirect,
        showMessage
      })
  },

  /**
   * 結帳包套方案訂單項目
   * @param commit
   * @param cart
   * @param prepaidOrderId
   * @returns {*}
   */
  checkoutPrepaidOrderItem({ commit }, {
    cart,
    prepaidOrderId
  } = {}) {
    return request
      .post(`/merchant/member/prepaid/order/${prepaidOrderId}/checkout`, {
        ...cart
      }, {
        ...configRequest,
        name: 'checkoutPrepaidOrderItem'
      })
  },

  /**
   * 取得儲值金使用紀錄
   * @param commit
   * @param state
   * @param type
   * @param date
   * @param order_by
   * @param order
   * @returns {*}
   */
   fetchDepositHistory({
    commit,
    state
  }, {
    type = '',
    date = '',
    order_by,
    order,
  } = {}) {
    return request
      .post('/merchant/member/deposit/history/search', {
        type,
        date,
        order_by,
        order,
      }, {
        ...configRequest,
        name: 'fetchDepositHistory'
      })
  },

  /**
   * 取得儲值金訂單
   * @param commit
   * @param state
   * @param status
   * @param orderBy
   * @param limit
   * @param page
   * @param date
   * @returns {*}
   */
   fetchDepositOrder({
    commit,
    state
  }, {
    status = '',
    orderBy = '',
    limit = '',
    page = 1,
    date,
  } = {}) {
    return request
      .post('/merchant/member/deposit/order/search', {
        status,
        orderBy,
        limit,
        page,
        date,
      }, {
        ...configRequest,
        name: 'fetchDepositOrder'
      })
  },
};
